<template>
  <div>
    <div id="livechat" v-if="$store.getters.getPackage == 'premium'">
      <v-layout wrap fill-height>
        <v-flex xs3 fill-height style="border-right: 1px solid #eee">
          <div id="chattype" class="text-xs-center">
            <v-layout>
              <template
                v-if="
                  !['universalutilities', 'hafele', 'scgallrent', 'scgworkplace', 'nvbb'].includes(
                    selectedBot.theme
                  ) && !['103003014894231'].includes(this.selectedBot.pageid)
                "
              >
                <v-flex v-if="selectedBot.theme != 'scgworkplace'" style="position: relative">
                  <v-btn
                    depressed
                    style="border-radius: 0; width: 100%"
                    class="ma-0"
                    :color="app == 'facebook' ? 'primary' : 'grey'"
                    @click="changeApp('facebook')"
                    dark
                  >
                    <i class="fab fa-facebook"></i>
                  </v-btn>
                  <div class="newnotifycount" v-if="facebooknotify">
                    {{ facebooknotify }}
                  </div>
                </v-flex>
              </template>
              <v-flex style="position: relative">
                <v-btn
                  depressed
                  style="border-radius: 0; width: 100%"
                  class="ma-0 pa-0"
                  :color="app == 'line' ? 'primary' : 'grey'"
                  @click="changeApp('line')"
                  dark
                >
                  <i class="fab fa-line"></i>
                </v-btn>
                <div class="newnotifycount" v-if="linenotify">
                  {{ linenotify }}
                </div>
              </v-flex>
              <v-flex>
                <v-dialog v-model="showSearch" width="500" persistent>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      depressed
                      style="border-radius: 0; width: 100%; position: relative; height: 100%"
                      class="ma-0 pa-0"
                      v-on="on"
                    >
                      <v-icon>search</v-icon>
                      <v-btn
                        v-if="input.search && selectedBot.theme == 'scgworkplace'"
                        icon
                        @click.stop="clearSearch"
                        small
                        style="position: absolute; right: 0; margin: 0"
                      >
                        <span style="font-size: 18px" class="material-icons">clear</span>
                      </v-btn>
                    </v-btn>
                  </template>

                  <v-card>
                    <div class="text-xs-right">
                      <v-btn flat fab small @click="showSearch = false">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </div>

                    <v-card-text>
                      <template v-if="selectedBot.theme == 'universalutilities'">
                        <div class="caption">{{ $t('ประปา') }}</div>
                        <div v-if="selectedBot.uu_areaname" class="primary--text">
                          {{ selectedBot.uu_areaname }}
                        </div>
                        <template v-else>
                          <v-select
                            :items="areaname"
                            v-model="input.uuAreaName"
                            label="ประปา"
                            placeholder="ประปา"
                            solo
                          ></v-select>
                        </template>
                        <v-layout wrap>
                          <v-flex sm6 style="padding-right: 1em">
                            <div class="form-control">
                              <label>ชื่อ</label>
                              <input v-model="input.uu_name" type="text" />
                            </div>
                          </v-flex>
                          <v-flex sm6 style="padding-right: 1em">
                            <div class="form-control">
                              <label>เบอร์โทร</label>
                              <input v-model="input.phoneno" type="number" />
                            </div>
                          </v-flex>
                          <v-flex sm6 style="padding-right: 1em">
                            <div class="form-control">
                              <label>LineID</label>
                              <input v-model="input.search" type="text" />
                            </div>
                          </v-flex>
                          <v-flex sm6>
                            <label>{{ $t('Register Status') }}</label>
                            <multiselect
                              v-model="input.uu_register_status"
                              :options="[
                                'ยังไม่กรอกข้อมูล',
                                'กรอกข้อมูลไม่สำเร็จ',
                                'ยังไม่กดส่งพิกัด',
                                'ลงทะเบียนสำเร็จ',
                                'กรอกข้อมูลไม่ครบ',
                              ]"
                              selectLabel
                              selectedLabel
                              deselect-label
                              :placeholder="$t('Register Status')"
                            ></multiselect>
                          </v-flex>
                          <!-- <v-flex sm12>
                            <div class="form-control">
                              <label>Keyword</label>
                              <input v-model="input.keyword" type="text" />
                            </div>
                          </v-flex>-->
                        </v-layout>
                        <v-layout>
                          <v-flex>
                            <div class="form-control">
                              <label>Last Conversation From</label>
                              <v-layout wrap>
                                <v-flex
                                  xs6
                                  class="form-control"
                                  :class="{ 'has-error': errors.has('startdate') }"
                                >
                                  <v-menu
                                    ref="openStartDate"
                                    v-model="openStartDate"
                                    :close-on-content-click="false"
                                    full-width
                                    max-width="290px"
                                    color="primary"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <input
                                        type="text"
                                        class="form-control browser-default"
                                        :placeholder="$t('Date')"
                                        readonly
                                        v-model="input.lastconversationfromdate"
                                        v-on="on"
                                        clearable
                                      />
                                    </template>
                                    <v-date-picker
                                      color="primary"
                                      v-model="input.lastconversationfromdate"
                                      @input="openStartDate = false"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-flex>
                                <v-flex xs4 class="pl-1">
                                  <v-menu
                                    ref="openStartTime"
                                    v-model="openStartTime"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    :return-value.sync="input.lastconversationfromtime"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    :disabled="input.lastconversationfromdate == null"
                                    max-width="290px"
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <input
                                        type="text"
                                        class="form-control browser-default"
                                        :placeholder="$t('Time')"
                                        readonly
                                        v-model="input.lastconversationfromtime"
                                        v-on="on"
                                        :disabled="input.lastconversationfromdate == null"
                                      />
                                    </template>
                                    <v-time-picker
                                      v-if="openStartTime"
                                      v-model="input.lastconversationfromtime"
                                      full-width
                                      @click:minute="
                                        $refs.openStartTime.save(input.lastconversationfromtime)
                                      "
                                    ></v-time-picker>
                                  </v-menu>
                                </v-flex>
                                <v-flex xs2>
                                  <v-btn
                                    fab
                                    flat
                                    small
                                    color="primary"
                                    style="height: 35px; width: 35px"
                                    @click="
                                      input.lastconversationfromdate = null
                                      input.lastconversationfromtime = null
                                    "
                                  >
                                    <v-icon>delete</v-icon>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-flex>
                          <v-flex>
                            <div class="form-control">
                              <label>Last Conversation To</label>
                              <v-layout wrap>
                                <v-flex
                                  xs6
                                  class="form-control"
                                  :class="{ 'has-error': errors.has('startdate') }"
                                >
                                  <v-menu
                                    ref="openEndDate"
                                    v-model="openEndDate"
                                    :close-on-content-click="false"
                                    full-width
                                    max-width="290px"
                                    color="primary"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <input
                                        type="text"
                                        class="form-control browser-default"
                                        :placeholder="$t('Date')"
                                        readonly
                                        v-model="input.lastconversationtodate"
                                        v-on="on"
                                        clearable
                                      />
                                    </template>
                                    <v-date-picker
                                      color="primary"
                                      v-model="input.lastconversationtodate"
                                      @input="openEndDate = false"
                                    ></v-date-picker>
                                  </v-menu>
                                </v-flex>
                                <v-flex xs4 class="pl-1">
                                  <v-menu
                                    ref="openEndTime"
                                    v-model="openEndTime"
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    :return-value.sync="input.lastconversationtotime"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    max-width="290px"
                                    min-width="290px"
                                    :disabled="input.lastconversationtodate == null"
                                  >
                                    <template v-slot:activator="{ on }">
                                      <input
                                        type="text"
                                        class="form-control browser-default"
                                        :placeholder="$t('Time')"
                                        readonly
                                        v-model="input.lastconversationtotime"
                                        v-on="on"
                                        :disabled="input.lastconversationtodate == null"
                                      />
                                    </template>
                                    <v-time-picker
                                      v-if="openEndTime"
                                      v-model="input.lastconversationtotime"
                                      full-width
                                      @click:minute="
                                        $refs.openEndTime.save(input.lastconversationtotime)
                                      "
                                    ></v-time-picker>
                                  </v-menu>
                                </v-flex>
                                <v-flex xs2>
                                  <v-btn
                                    fab
                                    flat
                                    small
                                    color="primary"
                                    style="height: 35px; width: 35px"
                                    @click="
                                      input.lastconversationtodate = null
                                      input.lastconversationtotime = null
                                    "
                                  >
                                    <v-icon>delete</v-icon>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-flex>
                        </v-layout>
                      </template>
                      <template v-if="selectedBot.theme != 'universalutilities'">
                        <div class="caption">{{ $t('Search') }}</div>
                        <div class="form-control">
                          <input type="text" v-model="input.search" :placeholder="$t('Search')" />
                        </div>
                      </template>
                      <v-btn block depressed @click="onSearch" color="primary">
                        {{ $t('Search') }}
                      </v-btn>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </v-flex>
            </v-layout>
            <v-tabs
              id="usertype"
              v-model="type"
              color="grey lighten-3"
              :slider-color="$vuetify.theme.primary"
              @change="changeType"
            >
              <v-tab ripple :key="'admin'" :href="'#admin'" style="position: relative">
                <div>
                  {{ $t('Admin') }}
                  <div
                    class="newnotifycount"
                    v-if="chatnotify && chatnotify.admin && chatnotify.admin != '0'"
                  >
                    {{ chatnotify.admin }}
                  </div>
                </div>
              </v-tab>
              <v-tab ripple :key="'bot'" :href="'#bot'" style="position: relative">
                <div>
                  {{ $t('chatbot') }}
                  <div
                    class="newnotifycount"
                    v-if="chatnotify && chatnotify.bot && chatnotify.bot != '0'"
                  >
                    {{ chatnotify.bot }}
                  </div>
                </div>
              </v-tab>
            </v-tabs>
          </div>
          <div v-if="app">
            <users
              :app="app"
              :usersearching="usersearching"
              :filter="filter"
              :type="'admin'"
              v-if="type == 'admin'"
            ></users>
            <users
              :app="app"
              :usersearching="usersearching"
              :filter="filter"
              :type="'bot'"
              v-if="type == 'bot'"
            ></users>
          </div>
        </v-flex>
        <v-flex
          xs5
          style="border-right: 1px solid #eee; position: relative"
          fill-height
          v-if="selectedUser"
          :key="`chat_${selectedUser.userid}_${selectedUser.type}`"
        >
          <chatbox
            @endSession="onEndSession"
            @openSession="onOpenSession"
            :key="selectedUser.userid"
          ></chatbox>
        </v-flex>
        <v-flex xs4 style="position: relative" fill-height v-if="selectedUser">
          <livechat-chattool :selectedUser="selectedUser"></livechat-chattool>
        </v-flex>
      </v-layout>
    </div>
    <div v-else style="position: relative">
      <v-premium-plan-popup
        backgroundColor="white"
        v-if="$store.getters.getPackage != 'premium'"
        style="border-radius: 10px; min-height: 100vh; height: 100%"
      ></v-premium-plan-popup>
    </div>
  </div>
</template>

<style></style>

<script>
import { mapGetters } from 'vuex'
import users from './livechat-users'
import chatbox from './livechat-chatbox'
import api from '@/api'
import LivechatChattool from './livechat-chattool'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    chatbox: chatbox,
    users: users,
    Multiselect,
    LivechatChattool,
  },
  data: function () {
    return {
      app: '',
      timer: '',
      type: 'bot',
      allrentcustomer: [],
      allrentsupplier: [],
      usersearching: false,
      toolListHeight: 0,
      showSearch: false,
      openStartDate: false,
      openStartTime: false,
      openEndDate: false,
      openEndTime: false,
      input: {
        uuAreaName: '',
        search: '',
        uu_register_status: '',
        lastconversationfromdate: null,
        lastconversationtodate: null,
        lastconversationfromtime: null,
        lastconversationtotime: null,
        lastconversationfrom: null,
        lastconversationto: null,
        phoneno: null,
        uu_name: null,
        keyword: '',
      },
      loading: false,
      newchatnotify: {},
    }
  },
  created: function () {
    var vm = this

    if (vm.$route.query.user) {
      vm.type = vm.$route.query.user == 'bot' ? 'bot' : 'admin'
    }
    if (vm.$route.query.userid) {
      var userid = vm.$route.query.userid

      if (userid) {
        vm.getUsersdata(userid).then(function (user) {
          if (user) {
            vm.selectedUser = {
              app: user.app,
              first_name: user.first_name,
              last_name: user.last_name,
              lastreply_time: null,
              profile_pic: user.profile_pic,
              session: '',
              sessionvalue: user.sessionvalue,
              userid: user.id,
              uu_areaname: null,
              type: user.context == 'contactadmin' ? 'admin' : '',
            }
          } else {
            vm.$swal({
              type: 'info',
              title: 'Not found this user',
            })
          }
        })
      }
    }

    if (this.selectedBot.theme == 'ticket') {
      this.$store.dispatch('loadAgents')
      this.$store.dispatch('loadAgentGroups')
      this.$store.dispatch('loadAgentSubGroups')
    }
    vm.livechatnotiunread()
    vm.timer = setInterval(() => {
      vm.livechatnotiunread()
    }, vm.$store.state.livechat.maxFatchUserTime)
  },
  beforeDestroy: function () {
    clearInterval(this.timer)
  },

  mounted: function () {
    var vm = this

    if (
      ['universalutilities', 'hafele', 'scgallrent', 'scgworkplace', 'nvbb'].includes(
        vm.selectedBot.theme
      ) ||
      this.$route.query.app == 'line' ||
      ['103003014894231'].includes(this.selectedBot.pageid)
    ) {
      vm.app = 'line'
    } else {
      vm.app = 'facebook'
    }
  },
  computed: {
    facebooknotify() {
      if (this.newchatnotify.facebook_bot || this.newchatnotify.facebook_admin) {
        return (
          parseFloat(this.newchatnotify.facebook_bot) +
          parseFloat(this.newchatnotify.facebook_admin)
        )
      } else return ''
    },
    linenotify() {
      if (this.newchatnotify.line_bot || this.newchatnotify.line_admin) {
        return parseFloat(this.newchatnotify.line_bot) + parseFloat(this.newchatnotify.line_admin)
      } else return ''
    },
    chatnotify() {
      var vm = this
      if (vm.app == 'facebook') {
        return {
          admin: vm.newchatnotify.facebook_admin ? vm.newchatnotify.facebook_admin : '',
          bot: vm.newchatnotify.facebook_bot ? vm.newchatnotify.facebook_bot : '',
        }
      } else {
        return {
          admin: vm.newchatnotify.line_admin ? vm.newchatnotify.line_admin : '',
          bot: vm.newchatnotify.line_bot ? vm.newchatnotify.line_bot : '',
        }
      }
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
    }),
    selectedUser: {
      get() {
        return this.$store.state.livechat.currentUser
      },
      set(newVal) {
        this.$store.state.livechat.currentUser = newVal
      },
    },
    filter() {
      return this.$store.state.filter
    },
    areaname: function () {
      var area = this.$store.state.uuAreaName
      area.unshift('')
      return area
    },
  },
  methods: {
    livechatnotiunread() {
      api.livechatnotiunread({ pageid: this.selectedBot.pageid }, (err, response) => {
        this.newchatnotify = response.data[0]
      })
    },
    changeApp(type) {
      this.app = type
      this.$store.dispatch('updateLivechatUser', null)

      this.updateRoute()
    },
    onSearch(e) {
      let vm = this
      if (vm.input.lastconversationfromdate) {
        vm.input['lastconversationfrom'] =
          vm.input.lastconversationfromdate +
          (vm.input.lastconversationfromtime ? ' ' + vm.input.lastconversationfromtime : ' 00:00')
      } else {
        vm.input['lastconversationfrom'] = null
      }

      if (vm.input.lastconversationtodate) {
        vm.input['lastconversationto'] =
          vm.input.lastconversationtodate +
          (vm.input.lastconversationtotime ? ' ' + vm.input.lastconversationtotime : ' 23:59')
      } else {
        vm.input['lastconversationto'] = null
      }
      Object.assign(vm.$store.state.filter, vm.input)
      vm.$store.state.filter.search = vm.input.search
      vm.usersearching = true
      vm.$store.dispatch('forceLoadLastestUsers').then(() => {
        vm.usersearching = false
      })
      vm.showSearch = false
    },
    clearSearch() {
      var vm = this
      vm.input.search = ''
      vm.usersearching = true
      vm.$store.dispatch('forceLoadLastestUsers').then(() => {
        vm.usersearching = false
      })
    },
    getUsersdata: function (userid) {
      var vm = this
      return new Promise((resolve, reject) => {
        var data = {
          userid: userid,
          pageid: vm.selectedBot.pageid,
        }

        api.getUsersdata(data, function (error, response) {
          if (error) {
            reject(error)
          }

          if (response.data) {
            resolve(response.data[0])
          } else {
            resolve(undefined)
          }
        })
      })
    },
    onEndSession: function () {
      this.$set(this.$store.state.livechat, 'currentUser', null)
      this.$store.dispatch('updateLivechatUser', null)
      this.$store.dispatch('forceLoadLastestUsers')
    },
    onOpenSession: function () {
      this.type = 'admin'
      var user = this.$store.state.livechat.currentUser
      user.type = this.type
      this.$store.dispatch('updateLivechatUser', user)
      this.$store.dispatch('forceLoadLastestUsers')
      this.updateRoute()
    },
    changeType: function (name) {
      this.type = name
      this.$store.dispatch('updateLivechatUser', null)
      this.updateRoute()
    },
    updateRoute: function () {
      var query = { ...this.$route.query }
      query.app = this.app
      query.user = this.type

      this.$router.push({
        name: 'livechat',
        path: '/livechat',
        query: query,
      })
      this.routeValue = JSON.stringify(this.$route.query)
    },
    sendMessage: function (payload) {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid,
        userid: payload.data.user.userid,
        adminid: this.$store.state.userid,
        app: payload.data.app,
        messagetype: payload.data.type,
        messagevalue: payload.data.text,
        page_access_token: vm.selectedBot.page_access_token,
      }
      let message = {
        answerby: 'admin',
        id: new Date().getTime(),
        messagedata: payload.data.text,
        messagetype: payload.data.type,
        pageid: vm.selectedBot.pageid,
        timestamp: new Date(),
        userid: payload.data.user.userid,
      }

      api.sendMessage(data, function (error, response) {
        if (error) {
          console.error(error)
          // vm.$store.dispatch('loading')
          return
        }
        // vm.$store.dispatch('loading')
      })
    },
  },
  watch: {
    selectedBot: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.$set(this.$store.state.livechat, 'currentUser', null)
      }
    },
  },
}
</script>
<style>
.newnotifycount {
  height: 16px;
  line-height: 16px;
  border-radius: 15px;
  position: absolute;
  right: 3px;
  top: 5px;
  background-color: #ff6565;
  width: 15px;
  font-size: 10px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/Livechat.vue